/* eslint-disable import/prefer-default-export */
import { TFunction } from "i18next"

export const expenditureProfileBreadCrumb = (t: TFunction<"translation", undefined>) => [
  {
    name: t("carbExpProfile.breadCrumbHeading"),
  },
]
